import { useLocation } from 'react-router-dom';
import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../content/utils.js';
import { DeleteBlueIcon } from '../../icons/DeleteBlueIcon.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import {
  EditStakeholderLink,
  StakeholderProfileLink,
} from '../../links/index.jsx';
import DownloadReportIcon from '../../icons/DownloadReportIcon.jsx';
import { EyeIcon } from '../../icons/EyeIcon.jsx';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const StakeholderProfileActionsDropdown = ({
  projectId,
  stakeholderId,
  onDelete,
  isReportLoading,
  onDownloadReport,
  actionsPosition,
  isArchived,
}) => {
  const location = useLocation();
  const route = location.pathname;

  return (
    <div className={`actions ${actionsPosition}`}>
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
      >
        {route === '/projects/stakeholders' ? (
          <StakeholderProfileLink
            stakeholderId={stakeholderId}
            projectId={projectId}
          >
            <CustomMenuItem>
              <span className="flex">
                <EyeIcon />
                <span>&nbsp; View</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </StakeholderProfileLink>
        ) : null}
        {isArchived ? (
          <>
            <CustomMenuItem
              onClick={() =>
                window.alert(getOrgTermsContent('archivedProjectMessage'))
              }
            >
              <span className="flex">
                <EditBlueIcon />
                <span>&nbsp; Edit</span>
              </span>
            </CustomMenuItem>
            <MenuItem divider />
          </>
        ) : (
          <EditStakeholderLink
            projectId={projectId}
            stakeholderId={stakeholderId}
          >
            <CustomMenuItem>
              <span className="flex">
                <EditBlueIcon />
                <span>&nbsp; Edit</span>
              </span>
            </CustomMenuItem>
            <CustomMenuItem divider />
          </EditStakeholderLink>
        )}

        <CustomMenuItem>
          <button
            role="button"
            className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
            disabled={isReportLoading}
            onClick={onDownloadReport}
          >
            <DownloadReportIcon />
            <span className="m-l-8">
              {isReportLoading ? 'Loading...' : 'Download Report'}
            </span>
          </button>
        </CustomMenuItem>
        <MenuItem divider />
        {isArchived ? (
          <CustomMenuItem>
            <button
              className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
              onClick={() =>
                window.alert(getOrgTermsContent('archivedProjectMessage'))
              }
            >
              <DeleteBlueIcon />
              &nbsp; Delete
            </button>
          </CustomMenuItem>
        ) : (
          <CustomMenuItem>
            <button
              className="flex flex-align-center w-100 h-100 p-0 btn-clear bg-transparent"
              onClick={onDelete}
            >
              <DeleteBlueIcon />
              &nbsp; Delete
            </button>
          </CustomMenuItem>
        )}
      </DropdownButton>
    </div>
  );
};

export default StakeholderProfileActionsDropdown;
